import axios from "axios";
import { API_URL } from "../config/apiConfig";
import { clearSessionAndRedirectToLogin } from "../utils/authSession";

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = String(error.config?.url ?? "");
    if (status === 401) {
      const skipRedirect =
        url.includes("/auth/signin") ||
        url.includes("/auth/signup") ||
        url.includes("/verification/") ||
        url.includes("/auth/reset-password") ||
        url.includes("/password-reset/");
      if (!skipRedirect) {
        clearSessionAndRedirectToLogin();
      }
    }
    return Promise.reject(error);
  }
);
